var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBriefcase = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7 4.85A2.85 2.85 0 0 1 9.85 2h4a2.85 2.85 0 0 1 2.85 2.85V6h2.15a2.85 2.85 0 0 1 2.85 2.85v10a2.85 2.85 0 0 1-2.85 2.85h-14A2.85 2.85 0 0 1 2 18.85v-10A2.85 2.85 0 0 1 4.85 6H7zM4.85 7.7A1.15 1.15 0 0 0 3.7 8.85v4.675A23.1 23.1 0 0 0 11.85 15c2.87 0 5.616-.522 8.15-1.475V8.85a1.15 1.15 0 0 0-1.15-1.15zM15 6H8.7V4.85c0-.635.515-1.15 1.15-1.15h4c.635 0 1.15.515 1.15 1.15zm5 9.333a24.8 24.8 0 0 1-8.15 1.367c-2.853 0-5.596-.481-8.15-1.367v3.517c0 .635.515 1.15 1.15 1.15h14A1.15 1.15 0 0 0 20 18.85zm-9-2.483c0-.47.38-.85.85-.85h.01a.85.85 0 1 1 0 1.7h-.01a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})));
export default SvgBriefcase;